import { LayoutPublic } from 'components/layout';
import { LoadingSpinner } from 'components/ui';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import {
  useGetUserInfoQuery,
  useSetStoreSubscriptionChargesMutation,
} from 'store/services/segmentsApi';
import { useQuery } from 'utils/useQuery';

enum QueryParams {
  CHARGE_ID = 'charge_id',
  STORE = 'store',
}

export const ChargeConfirmationPage = () => {
  const query = useQuery();
  const chargeId = query.get(QueryParams.CHARGE_ID);
  const store = query.get(QueryParams.STORE);
  const history = useHistory();

  const [setCharges] = useSetStoreSubscriptionChargesMutation();

  const { data: completeUserInfo } = useGetUserInfoQuery();

  useEffect(() => {
    if (chargeId && store && completeUserInfo) {
      const hasUserOnboarded = completeUserInfo?.has_objectives;
      setCharges({
        storeName: store,
        chargeId,
      })
        .unwrap()
        .then(() => {
          query.delete(QueryParams.CHARGE_ID);
          query.delete(QueryParams.STORE);
          query.set('store_name', store as string);
          history.replace({
            pathname: hasUserOnboarded
              ? '/dashboard/welcome'
              : '/onboarding/profile',
            search: query.toString(),
          });
        });

      return;
    }
  }, [chargeId, completeUserInfo, history, query, setCharges, store]);

  return (
    <LayoutPublic>
      <div className="flex items-center justify-center">
        <LoadingSpinner className="w-20 h-20 text-segments-accent-color-orange" />
      </div>
    </LayoutPublic>
  );
};
